import { optionsToStrategy } from "@/common/utils/optionsToStrategy"

export const winnerOperationKlassOptions = [
  {label: 'Sistema', value: 'Base::Tmais::Raffles::SelectWinnerBySystem'},
  {label: 'Federal', value: 'Base::Tmais::Raffles::SelectWinnerByFederalLottery'},
]

export const winnerOperationKlassStrategy = optionsToStrategy(winnerOperationKlassOptions)